class JobMatchProfileOnConferenceController {
    /*@ngInject*/
    constructor($rootScope, $scope, $timeout, jobService, jobMatchService, companyService, meetingService, alertsAndNotificationsService, sharedService, jobMatchActionsService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedService = sharedService;
        this.jobMatchActionsService = jobMatchActionsService;
    }
    $onChanges(changes) {
        if (this._areElementsResolved(changes)) {
            this._init();
        }
    }
    _areElementsResolved(changes) {
        let hasUsersListChanged = changes.usersToEditFeedback !== undefined && changes.usersToEditFeedback.currentValue !== changes.usersToEditFeedback.previousValue && changes.candidateId == undefined;
        return !hasUsersListChanged;
    }
    _init() {
        console.warn("Job match profile on conference reloading ");
        this.isLoading = true;
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this.isCandidateContactDetailsMissing = false;
        this._getData();
        if (this.externalMeetingCallId && !this.refreshBookletEventListener) {
            this._setMeetingListener();
        }
    }
    _setMeetingListener() {
        this.refreshBookletEventListener = this.$rootScope.$on("REFRESH_CANDIDATE_BOOKLET", (event, message) => {
            this._init();
        });
    }
    _getData() {
        this.isLoading = true;
        this.getEnabledWorkflowSteps(() => {
            this.getCandidateJobMatchCardInfo(() => {
                if (this.workflowStep === 'rs') {
                    this._checkAvailableFeedbackReports(() => {
                        this._initFileNames();
                        this._loadTabs();
                        this.isLoading = false;
                    });
                }
                else {
                    this.getMoveToInterviewStepPossibility(() => {
                        this._checkAvailableFeedbackReports(() => {
                            this._initFileNames();
                            this._loadTabs();
                            this.isLoading = false;
                        });
                    });
                }
            });
        });
    }
    getEnabledWorkflowSteps(successCallback) {
        this.jobService.getEnabledWorkflowSteps(this.jobId, (data) => {
            this.enabledWorkflowSteps = data;
            this.steps = [];
            this.steps.push("Outreach");
            angular.forEach(this.enabledWorkflowSteps, (step, key) => {
                this.steps.push(step);
            });
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getCandidateJobMatchCardInfo(successCallback) {
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.jobMatchInfo = data;
            this.jobMatchInfo.name = data.firstName + ' ' + data.lastName;
            this.jobLocation = "";
            if (this.jobMatchInfo.jobLocation !== null) {
                this.jobLocation = this.jobService.getParsedJobLocationText(this.jobMatchInfo.jobLocation, false);
            }
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            this.jobMatchInfo.candidateInformationList = this._setCandidateEmailSubjectAndBody(this.jobMatchInfo).candidateInfoInEmailBody;
            this._checkIfContactDetailsMissing();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setCandidateEmailSubjectAndBody(candidate) {
        let candidateInformation = {};
        candidateInformation.subject = `Candidate Information: ${candidate.firstName ? candidate.firstName : ""} ${candidate.lastName ? candidate.lastName : ""} – ${candidate.jobMatchTitle} (Req #${candidate.jobMatchRequisitionNum})`;
        candidateInformation.body = '';
        candidate.candidateAdditionalDetails.preferredWorkLocations = candidate.workLocations;
        candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetails);
        return candidateInformation;
    }
    getMoveToInterviewStepPossibility(successCallback) {
        if (this.scheduleId) {
            this.meetingService.getMoveToInterviewStepPossibility(this.scheduleId, (data) => {
                this.jobMatchInfo.interviewNextStep = data.interviewNextStep;
                this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = data.canMoveCandidateToInterviewAfterCurrentFeedback;
                if (successCallback) {
                    successCallback();
                }
            }, error => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            successCallback();
        }
    }
    _checkAvailableFeedbackReports(successCallback) {
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
            let feedbackReports = data.feedbackReportsAvailability;
            this.isRecruiterScreeningFeedbackAvailable = feedbackReports["recruiterScreeningFeedbackReport"];
            this.isPhoneScreenFeedbackAvailable = feedbackReports["phoneScreenFeedbackReport"];
            this.isInterviewFeedbackAvailable = feedbackReports["interviewFeedbackReport"];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _initFileNames() {
        this.outreachFeedbackFileName = this.generalFileName + '-outrachFeedback' + '.pdf';
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.taFileName = this.generalFileName + '-' + this.jobMatchInfo.techAssessmentName + '.pdf';
        this.vaFileName = this.generalFileName + '-' + this.jobMatchInfo.valueAssessmentName + '.pdf';
        this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    }
    _loadTabs() {
        this.tabs = [];
        this.validTabs = [];
        this._loadWorkflowSteps();
        this._loadValidTabs();
        this._setActiveTab();
    }
    _loadWorkflowSteps() {
        this.sectionalReport = false;
        if (this.jobMatchInfo.isSharedRequisition && !this.isCorporateFlag) {
            this.sectionalReport = true;
        }
        if (!_.isNull(this.jobMatchInfo.techAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.techAssessmentScore) && this.jobMatchInfo.techAssessmentScore.toString() != '') {
            this.taUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.techAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.techAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: 'Tech Assessment', step: 'Tech Assessment', fileName: this.taFileName, url: this.taUrl, isLoading: false });
        }
        if (!_.isNull(this.jobMatchInfo.valueAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.valueAssessmentScore) && this.jobMatchInfo.valueAssessmentScore.toString() != '') {
            this.vaUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.valueAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.valueAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: "Value Assessment", step: 'Value Assessment', fileName: this.vaFileName, url: this.vaUrl, isLoading: false });
        }
        if (this.workflowStep === 'rs') {
            this.tabs.push({ name: 'Feedback', step: 'Recruiter Screening', feedbackType: 'Screening', isActive: true });
        }
        if (this.workflowStep === 'ps' && this.displayFeedback) {
            this.feedbackType = 'Phone Screen';
            this.itemType = "phoneScreen";
            if (this.displaySchedules) {
                if (this.jobMatchInfo.currentStep == "Interview") {
                    this.tabs.push({ name: 'Phone Screen', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: false, displayFeedback: true });
                    this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: false });
                }
                else {
                    this.tabs.push({ name: 'Phone Screen', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: true, displayFeedback: true });
                }
                if (this.jobMatchInfo.interviewNextStep) {
                    this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: false, disabled: true, message: "The Phone screen feedback(s) of the candidate have to be completed and the candidate has to be moved to the interview step before an interview can be scheduled." });
                }
            }
            else {
                if (this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Completed Feedback", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
                }
                this.tabs.push({ name: 'Feedback', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: true });
            }
        }
        if (this.workflowStep === 'in' && this.displayFeedback) {
            this.feedbackType = 'Interview';
            this.itemType = "interview";
            if (this.jobMatchInfo.outreachReport) {
                this.outreachReportUrl = "api/jobmatch/outreachFeedbackReport/" + this.jobMatchId + "?companyId=" + this.companyId;
                this.tabs.push({ name: "Outreach", step: "Outreach", fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, isLoading: false });
            }
            if (this.displaySchedules) {
                this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: true, disabled: false });
                if (this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Phone Screen(s)", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
                }
                if (this.isRecruiterScreeningFeedbackAvailable) {
                    this.recruiterScreeningFeedbackUrl = "api/jobmatch/getscreeningfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Recruiter Screening", step: 'Recruiter Screening', fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, isLoading: false });
                }
            }
            else {
                if (this.displayPhoneScreenCompletedFeedbacks && this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Completed Feedback", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false, isActive: true });
                }
                else if (this.isInterviewFeedbackAvailable) {
                    this.interviewFeedbackUrl = "api/jobmatch/getinterviewfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Completed Feedback", step: "Interview", fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
                }
                if (!this.displayPhoneScreenCompletedFeedbacks) {
                    this.tabs.push({ name: 'Feedback', step: 'Interview', feedbackType: 'Interview', isActive: true });
                }
            }
        }
    }
    _loadValidTabs() {
        let isProfileActive = !this.displayFeedback;
        if (this.workflowStep == 'rs') {
            isProfileActive = false;
        }
        let candidateProfileTab = { name: 'Profile', step: 'Profile', isActive: isProfileActive };
        this.validTabs.push(candidateProfileTab);
        this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
        this.validTabs.push({ name: 'Compare', step: 'Compare' });
        angular.forEach(this.steps, (step, index) => {
            angular.forEach(this.tabs, (tab, tabIndex) => {
                if (tab.step == step) {
                    this.validTabs.push(tab);
                }
            });
        });
        if (this.displayCommunication) {
            this.validTabs.push({ name: 'Communication', step: 'Communication' });
        }
    }
    _setActiveTab() {
        this.activeTab = this.validTabs.findIndex(tab => tab.isActive == true);
    }
    moveToInterviewCallback() {
        this._getData();
    }
    _checkIfContactDetailsMissing() {
        let jobMatchInfo = _.cloneDeep(this.jobMatchInfo);
        jobMatchInfo.candidateAdditionalDetails.workLocations = this.jobMatchInfo.workLocations;
        if (!this.sharedService.isContactDetailsAvailable(jobMatchInfo, 'candidateJobMatchCard') || !this.sharedService.isCandidateAdditionalDetailsAvailable(jobMatchInfo)) {
            this.isCandidateContactDetailsMissing = true;
        }
        else {
            this.isCandidateContactDetailsMissing = false;
        }
    }
    $onDestroy() {
        if (this.externalMeetingCallId && this.refreshBookletEventListener) {
            this.refreshBookletEventListener();
        }
    }
}
JobMatchProfileOnConferenceController.$inject = ['$rootScope', '$scope', '$timeout', 'jobService', 'jobMatchService', 'companyService', 'meetingService', 'alertsAndNotificationsService', 'sharedService', 'jobMatchActionsService'];
import * as TEMPLATE from 'raw-loader!./job-match-profile-on-conference.html';
export const JobMatchProfileOnConferenceComponent = {
    selector: 'jobMatchProfileOnConference',
    component: {
        bindings: {
            jobMatchId: '@',
            jobId: '@',
            candidateId: '@',
            scheduleId: '@',
            workflowStep: '@',
            feedbackUserIdsList: '@',
            context: '@',
            displayFeedback: '<',
            displaySchedules: '<',
            displayCommunication: '<',
            displayPhoneScreenCompletedFeedbacks: '<',
            saveCallback: '&',
            completeFeedbackCallback: '&',
            usersToEditFeedback: '<',
            feedbackReadOnly: '<',
            externalMeetingCallId: '<',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: JobMatchProfileOnConferenceController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/conference/conference/jobMatchProfileOnConference/job-match-profile-on-conference.html'
    }
};
//# sourceMappingURL=job-match-profile-on-conference.component.js.map